module.exports = __webpack_public_path__ + "images/ccfca45abb953c1052c85e6777be4835.svg";